import isOutOfViewport from './vendor/isOutOfViewport';

const contextAwareMenu = (elems) => {
  const menuItems = document.querySelectorAll('.wp-block-navigation-submenu');

  const onMouseEnter = (e) => {
    const menu = e.currentTarget.querySelector(
      '.wp-block-navigation__submenu-container'
    );

    if (menu) {
      const boundingData = isOutOfViewport(menu);

      if (boundingData.left && boundingData.right) {
        menu.classList.add('is-context-aware');
      } else if (boundingData.left) {
        menu.classList.add('is-context-aware-left');
      } else if (boundingData.right) {
        menu.classList.add('is-context-aware-right');
      }
    }
  };

  [...menuItems].forEach((menuItem) => {
    menuItem.addEventListener('mouseenter', onMouseEnter);
    menuItem.addEventListener('click', onMouseEnter);
  });
};

export default contextAwareMenu;
